const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.6666 3.33366C11.6666 2.41318 10.9204 1.66699 9.99992 1.66699C9.07944 1.66699 8.33325 2.41318 8.33325 3.33366C8.33325 4.25413 9.07944 5.00033 9.99992 5.00033C10.9204 5.00033 11.6666 4.25413 11.6666 3.33366Z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.6666 10.0003C11.6666 9.07985 10.9204 8.33366 9.99992 8.33366C9.07944 8.33366 8.33325 9.07985 8.33325 10.0003C8.33325 10.9208 9.07944 11.667 9.99992 11.667C10.9204 11.667 11.6666 10.9208 11.6666 10.0003Z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.6666 16.667C11.6666 15.7465 10.9204 15.0003 9.99992 15.0003C9.07944 15.0003 8.33325 15.7465 8.33325 16.667C8.33325 17.5875 9.07944 18.3337 9.99992 18.3337C10.9204 18.3337 11.6666 17.5875 11.6666 16.667Z"
});

const SvgEllipsis = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEllipsis, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ellipsis.18119c79.svg";
export { ForwardRef as ReactComponent };